// Function to detect the appropriate CSV separator based on locale
const detectLocaleSeparator = (): string => {
  // Check if running in browser environment
  if (typeof navigator === 'undefined') {
    return ','; // Default to comma if not in browser
  }

  // Get user's language
  const userLang = navigator.language || (navigator.languages && navigator.languages[0]);

  // List of locales that commonly use semicolons in CSV
  const semicolonLocales = ['pt-BR', 'pt', 'it', 'fr', 'es', 'de', 'nl'];

  // Check if user's locale is in the semicolon-using list
  if (userLang && semicolonLocales.some(locale => userLang.toLowerCase().startsWith(locale.toLowerCase()))) {
    return ';';
  }

  return ','; // Default to comma for other locales
};

const convertToCSV = (data: object[], separator: string = ',') => {
  if (data.length === 0) {
    return '';
  }

  // Function to properly escape CSV field values
  const escapeField = (field: unknown): string => {
    const stringField = String(field ?? "");
    // Check if field needs escaping (contains separator, quote, or newline)
    if (stringField.includes(separator) || stringField.includes('"') || stringField.includes('\n')) {
      // Escape quotes by doubling them and wrap the field in quotes
      return `"${stringField.replace(/"/g, '""')}"`;
    }
    return stringField;
  };

  const headers = Object.keys(data[0]);
  const headerRow = headers.map(escapeField).join(separator);

  const rows = data.map(row => {
    return headers.map(header => escapeField(row[header as keyof typeof row])).join(separator);
  });

  return headerRow + '\n' + rows.join('\n');
};

export const downloadCSV = (data: object[], fileName: string) => {
  // If separator is not explicitly provided, detect it based on locale
  const actualSeparator = detectLocaleSeparator();

  // Add UTF-8 BOM for better encoding recognition
  const BOM = '\uFEFF';
  const csvContent = BOM + convertToCSV(data, actualSeparator);
  const csvData = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
  const csvURL = URL.createObjectURL(csvData);
  const link = document.createElement('a');
  link.href = csvURL;
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
